"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconPeopleManGraduate = /*#__PURE__*/
function (_Icon) {
  _inherits(IconPeopleManGraduate, _Icon);
  function IconPeopleManGraduate(props) {
    var _this;
    _classCallCheck(this, IconPeopleManGraduate);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconPeopleManGraduate).call(this, props));
    _this.name = 'IconPeopleManGraduate';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "people-man-graduate_svg__group0"
    }, _react2.default.createElement("path", {
      className: "people-man-graduate_svg__path0",
      d: "M12 13.997a3.015 3.015 0 01-1.8-.597.496.496 0 01-.1-.7.503.503 0 01.7-.1 2.014 2.014 0 002.4 0 .499.499 0 01.795.47.498.498 0 01-.195.33 3.015 3.015 0 01-1.8.597z"
    }), _react2.default.createElement("path", {
      className: "people-man-graduate_svg__path1",
      d: "M23 24a.5.5 0 01-.5-.5v-1.106a1.489 1.489 0 00-.575-1.183c-.834-.636-2.305-1.511-4.604-2.095l-4.631 4.415a1.001 1.001 0 01-1.38 0l-4.63-4.414c-2.295.584-3.77 1.459-4.607 2.096a1.483 1.483 0 00-.573 1.178V23.5a.5.5 0 01-1 0v-1.106a2.488 2.488 0 01.965-1.975C2.899 19.328 6.174 17.5 12 17.5c5.839 0 9.105 1.828 10.533 2.917.611.471.972 1.21.967 1.98V23.5a.5.5 0 01-.5.5zm-11-1.193l4.142-3.949A22.974 22.974 0 0012 18.5c-1.462 0-2.852.121-4.141.359L12 22.807z"
    }), _react2.default.createElement("circle", {
      className: "people-man-graduate_svg__circle0",
      cx: 14,
      cy: 10.5,
      r: 0.75
    }), _react2.default.createElement("circle", {
      className: "people-man-graduate_svg__circle1",
      cx: 10,
      cy: 10.5,
      r: 0.75
    }), _react2.default.createElement("path", {
      className: "people-man-graduate_svg__path2",
      d: "M12 17a6.508 6.508 0 01-6.5-6.5V4.534l-3-.682V8.37a7.657 7.657 0 011 4.154A.5.5 0 013 13H1a.5.5 0 01-.5-.477 7.65 7.65 0 011-4.154V3.395a.743.743 0 01-.095-.558.754.754 0 01.569-.569L11.666.062a1.484 1.484 0 01.665 0l9.706 2.206a.749.749 0 01-.001 1.463l-3.536.805V10.5c0 3.584-2.916 6.5-6.5 6.5zm-5.5-6.5c0 3.033 2.467 5.5 5.5 5.5s5.5-2.467 5.5-5.5V8.273C16.612 8.592 14.907 9 12 9s-4.612-.408-5.5-.727V10.5zM2.506 12A6.695 6.695 0 002 9.613 6.7 6.7 0 001.494 12h1.012zM6.5 7.195C7.068 7.448 8.691 8 12 8c3.308 0 4.931-.553 5.5-.806v-2.43l-5.162 1.174a1.49 1.49 0 01-.665 0L6.5 4.762v2.433zm5.394-2.232a.51.51 0 00.223 0L20.744 3l-8.633-1.963a.58.58 0 00-.223.001L3.265 3l8.629 1.963z"
    })));
    return _this;
  }
  return IconPeopleManGraduate;
}(_Icon3.default);
exports.default = IconPeopleManGraduate;